import { StorageService } from "./storage.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import { Uris } from "./Uris";

@Injectable({
  providedIn: "root"
})
export class ClientsService {
  constructor(
    public storageService: StorageService,
    private http: HttpClient,
    public router: Router
  ) {}

  getClients(query = "") {
    return this.http.get(`${Uris.CLIENTS}${query}`, this.storageService.headersSoloAdmin()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  /**
   * Obtiene el detalle de un cliente.
   * @param id Id del cliente.
   * @param query Query opcional (p. ej. `?fields=id,name`).
   * @returns Observable con el cliente.
   */
  getClient(id, query: string = "") {
    return this.http.get(`${Uris.CLIENTS}${id}/${query}`, this.storageService.headers(false)).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  postClient(value) {
    return this.http.post(`${Uris.CLIENTS}`, value, this.storageService.headers()).pipe(
      map((resp: any) => {
        this.storageService.animation(
          "success",
          "Éxito",
          `Cliente ${resp.user.username} creado correctamente`
        );
        return resp;
      })
    );
  }

  patchClient(id, value) {
    return this.http.patch(`${Uris.CLIENTS}${id}/`, value, this.storageService.headers()).pipe(
      map((resp: any) => {
        this.storageService.animation(
          "success",
          "Éxito",
          `${resp.user.username} editado correctamente`
        );
        return resp;
      })
    );
  }
  /**
   * Habilita o deshabilita el manejo de la alimentacion por administracion (NAS-SI) en un cliente.
   * El campo es de solo lectura en el patch normal del cliente, por eso existe esta ruta dedicada.
   * @param id - Id del cliente.
   * @param value - Nuevo valor del booleano.
   * @returns Observable con el id del cliente y el valor aplicado.
   */
  patchClientFeedingByAdmin(id: string | number, value: boolean) {
    return this.http
      .patch(
        `${Uris.CLIENTS}${id}/feeding_by_admin/`,
        { feeding_by_admin: value },
        this.storageService.headersSoloAdmin()
      )
      .pipe(map((resp: any) => resp));
  }

  /**
   * Elimina una empresa (cliente) de forma permanente.
   * @param id - Id del cliente a eliminar.
   * @returns Observable de la respuesta del backend.
   */
  deleteClient(id: string | number) {
    return this.http.delete(`${Uris.CLIENTS}${id}/`, this.storageService.headers()).pipe(
      map((resp: any) => {
        this.storageService.animation("success", "Éxito", "Empresa eliminada correctamente");
        return resp;
      })
    );
  }

  changeUserStatus(id: number, type: "enable" | "disable") {
    return this.http.post(`${Uris.USERS}${id}/${type}/`, {}, this.storageService.headers()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getClientFarms(query: string = "", id?: any) {
    const url = id ? `${Uris.FARM_CLIENTS}${id}/${query}` : `${Uris.FARM_CLIENTS}${query}`;

    return this.http.get(url, this.storageService.headers()).pipe(map((resp: any) => resp));
  }

  getClientReport(id) {
    return this.http.get(`${Uris.CLIENTS}${id}/get_report/`, this.storageService.headers()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getSeasons(query) {
    return this.http.get(`${Uris.SEASONS}${query}`, this.storageService.headers()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getSeason(id) {
    return this.http.get(`${Uris.SEASONS}${id}/`, this.storageService.headers()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  postSeason(obj: any) {
    return this.http.post(`${Uris.SEASONS}`, obj, this.storageService.headers()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  patchSeason(obj: any, id: any) {
    return this.http.patch(`${Uris.SEASONS}${id}/`, obj, this.storageService.headers()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }
  deleteSeason(id: any) {
    return this.http.delete(`${Uris.SEASONS}${id}/`, this.storageService.headersSoloAdmin()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  /**
   * Obtiene los clientes eliminados (soft-delete).
   * @param query - Query string con filtros y paginación.
   * @returns Observable con la lista paginada de clientes inactivos.
   */
  getInactiveClients(query: string = "") {
    return this.http
      .get(`${Uris.CLIENTS_INACTIVE}${query}`, this.storageService.headersSoloAdmin())
      .pipe(map((resp: any) => resp));
  }

  /**
   * Restaura clientes eliminados (soft-delete) por sus ids.
   * @param objects_ids - Ids de los clientes a restaurar.
   * @returns Observable con la respuesta del backend.
   */
  restoreClients(objects_ids: number[]) {
    return this.http
      .patch(`${Uris.CLIENTS_RESTORE}`, { objects_ids }, this.storageService.headersSoloAdmin())
      .pipe(map((resp: any) => resp));
  }
}
